<!--
 * @Description: 个人中心主入口
 * @Author: gao shuai
 * @Date: 2020-06-13 11:32:01
 * @LastEditTime: 2020-08-19 14:49:10
 * @LastEditors: gao shuai
-->
<template>
  <div class="main">
    <div class="header">
      <div class="headbox clearfix">
        <div class="logo">
          <img src="../../assets/images/logo.png" alt="" />
        </div>
        <ul class="navbox clearfix">
          <li>
            <span class="icon1" @click="refresh('/behalf/baseInfo')"
              >账户管理</span
            >
          </li>
          <li>
            <span class="icon1" @click="refresh('/audit/audit')">订单管理</span>
          </li>
          <li>
            <span class="icon1" @click="refresh('/rollout/everyday')"
              >转出统计</span
            >
          </li>
          <li>
            <span class="icon1" @click="refresh('/main/home')">返回平台</span>
          </li>
        </ul>
        <div class="count">{{ nickName }}</div>
      </div>
    </div>
    <div class="container">
      <div class="midleContaner">
        <div class="slider">
          <div class="top_tit">账户管理</div>
          <ul>
            <li>
              <span @click="refresh('/audit/audit')">待审核订单</span>
            </li>
            <li>
              <span @click="refresh('/audit/success')">已完成订单</span>
            </li>
            <li>
              <span @click="refresh('/audit/error')">错误账号</span>
            </li>
            <li>
              <span @click="refresh('/audit/blacklist')">黑名单管理</span>
            </li>
          </ul>
        </div>
        <div class="contentbox">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'personal',
  inject: ['reload'],
  data() {
    return {
      name: 'baseInfo'
    };
  },
  computed: {
    ...mapState(['userType', 'nickName'])
  },
  methods: {
    // 获取用户信息
    getUser() {
      this.$api.home
        .getUserinfo()
        .then(data => {
          this.$store.commit('saveuuid', data.data.uuid);
          this.$store.commit('saveType', data.data.type);
          this.$store.commit('changeNickName', data.data.userName);
          this.$store.commit('changeId', data.data.id);
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    // 跳转路由刷新
    refresh(path) {
      if (this.$route.path.indexOf(path) > -1) {
        this.reload();
      } else {
        this.$router.push({
          path: path
        });
      }
    }
  },
  mounted() {
    console.log(this.$route);
    this.name = this.$route.name;
  },
  created() {
    this.getUser();
  }
};
</script>

<style lang="scss" scoped>
.main {
  position: relative;
  padding-top: 60px;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background: #e6edf5;

  .header {
    position: absolute;
    width: 100%;
    height: 60px;
    top: 0;
    left: 0;
    background: #59bfe7;

    .headbox {
      width: 80vw;
      margin: 0 auto;
      height: 60px;

      .logo {
        margin-top: 13px;
        float: left;
      }

      .navbox {
        float: left;
        margin-top: 15px;
        margin-left: 50px;

        li {
          float: left;
          padding: 0 35px;
          height: 28px;
          line-height: 28px;
          border-right: 1px solid #fff;
          color: #fff;
          font-size: 16px;

          span {
            cursor: pointer;
          }
        }
      }

      .count {
        float: right;
        height: 28px;
        line-height: 28px;
        padding: 0 20px;
        margin-right: 30px;
        font-size: 19px;
        color: #fff;
        margin-top: 15px;
      }
    }
  }

  .container {
    height: 100%;
    box-sizing: border-box;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.5);
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.5);
      border-radius: 10px;
    }

    .midleContaner {
      width: 80vw;
      margin: 20px auto 22px auto;
      position: relative;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

      // box-shadow: 0 0 10px rgba(0, 0, 0, .25);
      .slider {
        position: absolute;
        width: 160px;
        background: #f4f4f4;
        height: 100%;
        left: 0;
        top: 0;

        .top_tit {
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-size: 16px;
          font-weight: bold;
          color: #fff;
          background: #59bfe7;
        }

        ul {
          li {
            height: 45px;
            line-height: 45px;
            color: #000;
            font-size: 14px;
            text-align: center;
            span {
              display: block;
              cursor: pointer;
              height: 45px;
              border-bottom: #e8e8e8 1px solid;
              margin: 0 15px;
              &.icon1 {
                background: url(../../assets/images/p_icon1.png) no-repeat 39px
                  center;
                background-size: auto 22px;
              }

              &.icon2 {
                background: url(../../assets/images/p_icon2.png) no-repeat 39px
                  center;
                background-size: auto 20px;
              }

              &.icon3 {
                background: url(../../assets/images/p_icon3.png) no-repeat 40px
                  center;
                background-size: auto 18px;
              }

              &.icon4 {
                background: url(../../assets/images/p_icon4.png) no-repeat 39px
                  center;
                background-size: auto 20px;
              }

              &.icon5 {
                background: url(../../assets/images/p_icon5.png) no-repeat 40px
                  center;
                background-size: auto 18px;
              }

              &.icon6 {
                background: url(../../assets/images/p_icon6.png) no-repeat 39px
                  center;
                background-size: auto 19px;
              }

              &.icon7 {
                background: url(../../assets/images/p_icon7.png) no-repeat 39px
                  center;
                background-size: auto 22px;
              }
            }
          }
        }
      }

      .contentbox {
        min-height: 800px;
        margin-left: 156px;
      }
    }
  }

  .areaContainer {
    padding: 0 0 20px 15px;

    li {
      position: relative;
      float: left;
      border: 1px solid #ddd;
      padding: 4px;
      cursor: pointer;
      margin-right: 17px;

      .imgbox {
        padding: 15px 8px;
      }

      .mask {
        display: none;
        position: absolute;
        top: 4px;
        left: 4px;
        width: 112px;
        height: 90px;
        background: rgba(0, 0, 0, 0.7);
        color: #fff;
        text-align: center;
        line-height: 90px;
      }

      &:hover {
        border-color: #00b066;

        .mask {
          display: block;
        }
      }

      img {
        display: block;
      }
    }
  }
}
</style>
